module.exports = __webpack_public_path__ + "static/media/tadasana.0d7cb44a.jpg";